import TipoCarreta from '../entities/TipoCarreta'
import IVeiculosRepository from '../repositories/IVeiculosRepository'

export interface IListTipoCarretas {
  execute(): Promise<TipoCarreta[]>
}

export default class ListTipoCarretas implements IListTipoCarretas {
  constructor(private readonly veiculosRepository: IVeiculosRepository) {}

  public async execute(): Promise<TipoCarreta[]> {
    return this.veiculosRepository.findAllTipoCarretas()
  }
}
